<template>
	<section class="flex flex-col h-full w-full overflow-hidden" :style="{minWidth: `${$sessionLayout.minSize}px`}">
		<header v-if="$slots.title" class="flex justify-between items-center mx-24 mt-24 mb-16 h-28">
			<h1 class="text-lg text-strong-base">
				<slot name="title" />
			</h1>
			<slot name="title-actions" />
			<BaseTooltip v-if="!isMobile" :enabled="tooltipEnabled" placement="bottom-end" text="Close panel">
				<BaseButton
					data-test="close-panel-button"
					class="text-gray-300 hover:bg-gray-650 hover:text-gray-100 h-28 w-28 rounded flex items-center justify-center"
					@click="closePanel"
				>
					<BaseIcon name="mono/delete" />
				</BaseButton>
			</BaseTooltip>
		</header>
		<main class="flex-grow overflow-hidden">
			<slot />
		</main>
	</section>
</template>

<script>
import {useWindowSize} from 'shared/composables/useWindowSize'

export default {
	name: 'SessionContentPanel',
	emits: ['close'],
	setup() {
		const {isMobile} = useWindowSize()
		return {isMobile}
	},
	data() {
		return {
			tooltipEnabled: true,
		}
	},
	methods: {
		closePanel() {
			this.tooltipEnabled = false
			this.$emit('close')
		},
	},
}
</script>
